import {
  AppBootstrapConfig,
} from '@refx/shared-common';

/**
 * DEFAULT specific bootstrap configuration for booking
 */
export const BOOKING_APP_BOOTSTRAP_CONFIG_DEFAULT: Partial<AppBootstrapConfig> = {
  gatewayClientId: 'hHTGWHFDeUFVdOztQWTC7zoe63E0k8zu',
  gatewayClientSecret: 'Zw2qeL9q2LXd6Ez0',
  loggingBaseUrl: 'https://uat.digital-logging.saas.amadeus.com' // TODO: remove when releasing 10.1. Enabled to collect logs from real user measurement
};
